// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type MilestoneReachedBy =
  | 'ADJUST_POINTS'
  | 'CASINO_BET'
  | 'SPORT_BET';

export type MilestoneStatus =
  | 'AVAILABLE'
  | 'CLAIMED'
  | 'PENDING'
  | 'SKIPPED'
  | 'UNAVAILABLE';

export type RewardCenterStatusQueryVariables = Exact<{
  site: string;
}>;


export type RewardCenterStatusQuery = { loyaltyPublic: { tiers: { edges: Array<{ node: { id: string, name: string | undefined, points: number | undefined, milestones: { edges: Array<{ node: { id: string, name: string | undefined, points: string | undefined, progress: number | undefined, status: Types.MilestoneStatus | undefined, rewardType: string | undefined, reachedBy: Types.MilestoneReachedBy | undefined, reward:
                  | { __typename: 'LoyaltyPublicBitcoinPricePromoOptions' }
                  | { __typename: 'LoyaltyPublicCashbackOptions' }
                  | { __typename: 'LoyaltyPublicFreespinOptions' }
                 | undefined } | undefined } | undefined> | undefined } | undefined } | undefined } | undefined> | undefined } | undefined, myMilestones: { edges: Array<{ node: { id: string, name: string | undefined, points: string | undefined, progress: number | undefined, status: Types.MilestoneStatus | undefined, rewardType: string | undefined, reachedBy: Types.MilestoneReachedBy | undefined, reward:
            | { __typename: 'LoyaltyPublicBitcoinPricePromoOptions' }
            | { __typename: 'LoyaltyPublicCashbackOptions' }
            | { __typename: 'LoyaltyPublicFreespinOptions' }
           | undefined } | undefined } | undefined> | undefined } | undefined, myStatus: { id: string | undefined, tierPoints: number | undefined, totalProgress: number | undefined, currentTier: { id: string, name: string | undefined, level: number | undefined, points: number | undefined, progress: number | undefined, milestones: { edges: Array<{ node: { name: string | undefined, points: string | undefined } | undefined } | undefined> | undefined } | undefined } | undefined, nextMilestone: { id: string, name: string | undefined, points: string | undefined, progress: number | undefined, status: Types.MilestoneStatus | undefined } | undefined } | undefined } | undefined };


export const RewardCenterStatusQueryDocument = gql`
    query RewardCenterStatusQuery($site: String!) {
  loyaltyPublic {
    tiers(site: $site) {
      edges {
        node {
          id
          name
          points
          milestones {
            edges {
              node {
                id
                name
                points
                progress
                status
                reward {
                  __typename
                }
                rewardType
                reachedBy
              }
            }
          }
        }
      }
    }
    myMilestones {
      edges {
        node {
          id
          name
          points
          progress
          status
          reward {
            __typename
          }
          rewardType
          reachedBy
        }
      }
    }
    myStatus {
      id
      tierPoints
      totalProgress
      currentTier {
        id
        name
        level
        points
        progress
        milestones {
          edges {
            node {
              name
              points
            }
          }
        }
      }
      nextMilestone {
        id
        name
        points
        progress
        status
      }
    }
  }
}
    `;